import { render, staticRenderFns } from "./RemoveMinuteEventIcon.vue?vue&type=template&id=8eb069be&"
import script from "./RemoveMinuteEventIcon.vue?vue&type=script&lang=js&"
export * from "./RemoveMinuteEventIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports